export function getRAv2Cic(state, sessionId) {
  return state
    .get('rootReducer')
    .get('rav2Cic')
    .get(sessionId);
}



// WEBPACK FOOTER //
// ./data/RAv2Cic/accessors.js